import {Component, OnInit} from '@angular/core';
import {Input} from '@angular/core';
import {EventEmitter} from '@angular/core';
import {Output} from '@angular/core';
import {OnChanges} from '@angular/core';
import {SimpleChanges} from '@angular/core';
import {Listing} from '../../../../classes/listing';
import {DeviceService} from '../../../../services/device/device.service';
import {ListingsService} from '../../../../services/listings.service';
import {PreferencesService} from '../../../../services/preferences.service';
import {ADD_SAVED_LISTING_PAGE_GTM, ADD_SAVED_LANDING_PAGE_GTM} from '../../../../classes/analytics-tags';
import { BritishColumbiaStateShort } from '../../../../app-config.constants';

@Component({
  selector: 'app-listing-summary-desktop-content',
  templateUrl: './listing-summary-desktop-content.component.html',
  styleUrls: ['./listing-summary-desktop-content.component.scss']
})
export class ListingSummaryDesktopContentComponent implements OnInit, OnChanges {
  @Input() listing: Listing;
  @Input() isLandingPageListing: boolean = false;
  @Output() toggleExpandedGalleryView: EventEmitter<boolean> = new EventEmitter();
  @Output() changeCarouselIndex: EventEmitter<number> = new EventEmitter();
  @Input() currentSlideIndex: number = 0;
  @Input() forceLuxuryStyle: boolean = false;
  @Input() showMap: boolean;
  @Input() readonly isMortgageApplicable: boolean = false;
  @Input() showVideoAndVirtualTour: boolean = true;
  @Input() showContactAgent: boolean = true;
  @Input() showScheduleViewing: boolean = true;
  @Input() showViewListingDetails: boolean = false;
  @Input() mortgagePaymentAmount: number = 0;
  @Output() showContactAgentClicked: EventEmitter<any> = new EventEmitter();
  @Output() showScheduleViewingClicked: EventEmitter<any> = new EventEmitter();
  @Output() homeEstimateLinkClick: EventEmitter<any> = new EventEmitter();

  priceOrPricePerSqFt: string;
  BritishColumbiaStateShort = BritishColumbiaStateShort;

  constructor(private deviceService: DeviceService,
              private preferencesService: PreferencesService,
              private listingService: ListingsService
            ) { }

  ngOnInit() {
    this.setPriceOrPricePerSqFt();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.listing) {
      this.setPriceOrPricePerSqFt();
    }
  }

  setPriceOrPricePerSqFt() {
    this.listingService.getPriceOrPricePerSqFtString(this.listing).subscribe(str => this.priceOrPricePerSqFt = str);
  }

  toggleFavourite($event) {
    $event.stopPropagation();
    this.listing.isFavourite = !this.listing.isFavourite;
    this.preferencesService.toggleFavouriteListing(this.listing.listingId, this.isLandingPageListing ? ADD_SAVED_LANDING_PAGE_GTM : ADD_SAVED_LISTING_PAGE_GTM);
    this.listing.getFavouriteIconToUse();
  }


  navigateToForm() {
    this.toggleExpandedGalleryView.emit(false);
    // if (this.listing.isLuxury || this.listing.isCommercial) {
      this.showContactAgentClicked.emit();
    // } else {
    //   // TODO: make this smooth
    //   const top = document.getElementById('contact-form').offsetTop;
    //   // TODO: make the first input focused on the contact form
    //   document.getElementById('contact-form').scrollIntoView(true);
    // }
  }
  navigateToScheduleForm () {
    this.toggleExpandedGalleryView.emit(false);
    this.showScheduleViewingClicked.emit();
  }
}
